export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="bg-slate-50 border-b border-slate-200" data-testid="page-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        {eyebrow && (
          <div className="text-xs font-bold uppercase tracking-widest text-[#FF6B00]">{eyebrow}</div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#0B192C] mt-2 tracking-tight max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-lg text-slate-600 max-w-2xl">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
